export const passwordCheck = (state={}, action) => {
    switch(action.type){
        case 'SET_PASSWORD_CHECK_CALCS':
            return {...state, calcs: action.calcs};
        case 'SET_PASSWORD_CHECK_FAILURE_CALCS':
            return {...state, failedCalcs: action.failedCalcs}
        default:
            return state;
    }

};